import React, { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Container, ContainerFluid } from "../../../../common/styles";
import CustomBreadCrumb from "../../../../components/breadcrumb";
import { BREADCRUMB_HUMBERGER_GLOBAL } from "../../../../constants/routes/drawer";
import { BREADCRUMB_DOCUMENTS, I18N_NS_DOCUMENTS } from "../../constants";
import { Tab, TabList } from "@fluentui/react-components";
import { ROUTES } from "../../../../constants/routes";
import withAuth from "../../../../HOC/withAuth";
import { roles_access, ROLES_CODE } from "../../../../constants/roles";

const TABLIST_VALUES = {
    my_documents: "my_documents",
    society: "society",
};

const HrDocumentsOutlet = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const isHR = roles_access({
        usersPrivileges: [ROLES_CODE.hr],
    });

    return (
        <ContainerFluid column styles={{ minHeight: "100vh" }}>
            <CustomBreadCrumb
                humberger={BREADCRUMB_HUMBERGER_GLOBAL}
                navList={BREADCRUMB_DOCUMENTS}
                i18n_ns={I18N_NS_DOCUMENTS}
            />
            <Container>
                <TabList
                    defaultSelectedValue={TABLIST_VALUES.my_documents}
                    selectedValue={
                        location.pathname.startsWith(ROUTES.document_hr.society)
                            ? ROUTES.document_hr.society
                            : ROUTES.document_hr.home
                    }
                    onTabSelect={(_, i) => {
                        const value = i.value;
                        return navigate(value);
                    }}
                    appearance="transparent"
                >
                    <Tab value={ROUTES.document_hr.home}>Mes documents</Tab>
                    {isHR && (
                        <Tab value={ROUTES.document_hr.society}>Entreprise</Tab>
                    )}
                </TabList>
            </Container>
            <Outlet />
        </ContainerFluid>
    );
};

export default withAuth(HrDocumentsOutlet);
